import { Player } from "./player";
import { getRandomInt } from "./utils";
const BOARD_SIZE = 10;

export class DOMController {
  constructor() {
    this.radar = document.querySelector("#radar");
    this.myBoard = document.querySelector("#my-board");
    this.winnerContainer = document.querySelector("#winner-container");
    this.restartButton = document.querySelector("#restart-button");
    this.restartButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.start();
    });
    this.start();
  }

  start() {
    this.radar.replaceChildren();
    this.myBoard.replaceChildren();
    this.winnerContainer.textContent = "";

    this.player = new Player(false, this.myBoard);
    this.cpu = new Player(true, this.radar);

    // Populate both boards
    this.populateBoard(this.player);
    this.populateBoard(this.cpu);

    // Add current locartions to player's board
    this.displayLocations(this.player);
  }

  populateBoard(player) {
    for (let y = BOARD_SIZE - 1; y >= 0; y--) {
      for (let x = 0; x < BOARD_SIZE; x++) {
        let button = document.createElement("button");
        button.classList = "clear";
        button.dataset.x = x;
        button.dataset.y = y;

        if (player == this.player) {
          button.disabled = true;
        } else {
          button.addEventListener("click", (e) => {
            e.preventDefault();

            let coordX = button.dataset.x;
            let coordY = button.dataset.y;

            button.disabled = true;

            if (this.cpu.gameboard.receiveAttack(coordX, coordY)) {
              button.classList = "hit";
            } else {
              button.classList = "miss";
            }

            if (this.cpu.gameboard.allSunk()) {
              this.winnerContainer.textContent = "You won!";
              this.finishGame();
            } else {
              setTimeout(() => {
                this.cpuTurn();
              }, 100);
            }
          });
        }

        player.boardContainer.appendChild(button);
      }
    }
  }

  cpuTurn() {
    while (true) {
      let coordX = getRandomInt(0, 10);
      let coordY = getRandomInt(0, 10);

      if (
        !this.player.gameboard.attacks.some(
          ([x, y]) => x === coordX && y === coordY,
        )
      ) {
        let button = this.player.boardContainer.querySelector(
          `[data-x="${coordX}"][data-y="${coordY}"]`,
        );

        if (this.player.gameboard.receiveAttack(coordX, coordY)) {
          button.classList = "hit";
          button.textContent = "X";
        } else {
          button.classList = "miss";
        }

        if (this.player.gameboard.allSunk()) {
          this.winnerContainer.textContent = "You lost!";
          this.finishGame();
        }
        break;
      }
    }
  }

  finishGame() {
    this.displayLocations(this.cpu);
    let allButtons = this.radar.querySelectorAll("button");
    allButtons.forEach((element) => {
      element.disabled = true;
    });
  }
  displayLocations(player) {
    player.gameboard.locations.forEach((location) => {
      for (let i = 0; i < location.ship.length; i++) {
        let coordX = location.x;
        let coordY = location.y;
        if (location.horizontal) {
          coordX += i;
        } else {
          coordY += i;
        }
        let attributes = `[data-x="${coordX}"][data-y="${coordY}"]`;

        let button = player.boardContainer.querySelector(attributes);
        if (i == 0) {
          button.textContent = "<";
        } else if (i == location.ship.length - 1) {
          button.textContent = ">";
        } else {
          button.textContent = "=";
        }

        if (!location.horizontal) {
          button.classList.add("rotate");
        }
      }
    });
  }
}
